import { makeAutoObservable } from 'mobx'

import { SmsStudent } from './SmsStudent'
import { SmsStudentGroup } from './SmsStudentGroup'

type ConstructorParams = {
  gradeStudentGroups: SmsStudentGroup[]
  classStudentGroups: SmsStudentGroup[]
}

export class SmsStudentGroupColl {
  private gradeStudentGroups: SmsStudentGroup[]
  private classStudentGroups: SmsStudentGroup[]
  sortType: '학년' | '반' = '학년'
  recipient: '학부모' | '학생' = '학부모'

  constructor(data: SmsStudentGroupColl | ConstructorParams) {
    makeAutoObservable(this)
    if (data instanceof SmsStudentGroupColl) {
      this.gradeStudentGroups = data.gradeStudentGroups.map(
        (studentGroup) => new SmsStudentGroup(studentGroup)
      )
      this.classStudentGroups = data.classStudentGroups.map(
        (studentGroup) => new SmsStudentGroup(studentGroup)
      )
      this.sortType = data.sortType
      this.recipient = data.recipient
    } else {
      this.gradeStudentGroups = data.gradeStudentGroups
      this.classStudentGroups = data.classStudentGroups
    }
  }

  get studentGroupList() {
    const studentGroups =
      this.sortType === '학년' ? this.gradeStudentGroups : this.classStudentGroups
    return studentGroups
  }

  get isGradeEmpty() {
    return this.studentGroupList.length === 0
  }

  get isClassEmpty() {
    return this.classStudentGroups.length === 0
  }

  get isNoneChecked() {
    return this.studentGroupList.every((studentGroup) => studentGroup.toCheckedArray.length === 0)
  }

  get checkSize() {
    return this.studentGroupList.reduce((prev, current) => {
      return prev + current.checkSize
    }, 0)
  }

  changeSortType(sortType: SmsStudentGroupColl['sortType']) {
    this.clearAllCheck()
    this.sortType = sortType
    this.setRecipient(this.recipient)
  }

  setRecipient(recipient: SmsStudentGroupColl['recipient']) {
    this.studentGroupList.forEach((studentGroup) => studentGroup.changeRecipient(recipient))
  }

  changeRecipient(recipient: SmsStudentGroupColl['recipient']) {
    this.clearAllCheck()
    this.recipient = recipient
    this.studentGroupList.forEach((studentGroup) => studentGroup.changeRecipient(recipient))
  }

  setCheck(student: SmsStudent) {
    this.studentGroupList.forEach((studentGroup) => studentGroup.setCheck(student))
  }

  deleteCheck(student: SmsStudent) {
    this.studentGroupList.forEach((studentGroup) => studentGroup.deleteCheck(student))
  }

  allCheck(studentGroup: SmsStudentGroup) {
    studentGroup.initialActiveList.forEach((student) => this.setCheck(student))
  }

  deleteAllCheck(studentGroup: SmsStudentGroup) {
    studentGroup.initialActiveList.forEach((student) => this.deleteCheck(student))
  }

  clearAllCheck() {
    this.studentGroupList.forEach((studentGroup) => studentGroup.clearAllCheck())
  }
}
